import Vue from "vue";
import VueRouter from "vue-router";
import { authGuard } from "@/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/Base.vue"),
    beforeEnter: (to, from, next) => {
      return authGuard(to, from, next);
    },
    children: [
      {
        path: "",
        name: "Home",
        component: () => import("@/views/Home.vue")
      },
      {
        path: "survey",
        name: "SurveySingle",
        props: true,
        component: () => import("@/views/SurveySingle.vue")
      },
      {
        path: "pdf/:id",
        name: "PDFSingle",
        props: true,
        component: () => import("@/views/PDFSingle.vue")
      },
      {
        path: "video/:id",
        name: "VideoSingle",
        props: true,
        component: () => import("@/views/VideoSingle.vue")
      },
      {
        path: "info",
        name: "Info",
        component: () => import("@/views/Info.vue")
      },
      {
        path: "info/single/:id",
        name: "InfoSingle",
        props: true,
        component: () => import("@/views/InfoSingle.vue")
      },
      {
        path: "quiz",
        name: "Quiz",
        component: () => import("@/views/Game.vue")
      }
    ]
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: () => import("@/views/Unauthorized.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router;
